import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import laptopImg from "../../Assets/aboutSection.svg";
import "./About.css";

function About() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "50px"
      }
    );

    const elements = document.querySelectorAll(
      ".about-section .scroll-reveal"
    );

    elements.forEach((element) => observer.observe(element));

    return () => {
      elements.forEach((element) => observer.unobserve(element));
    };
  }, []);

  const focusAreas = [
    "SOC Operations",
    "Threat Detection",
    "Incident Investigation",
    "Enterprise Networking",
    "Windows & Linux",
    "Active Directory",
    "Security Monitoring",
    "Infrastructure Support"
  ];

  return (
    <section className="about-section" id="about">
      <Container>
        <div className="about-header scroll-reveal">
          <span className="about-badge">About</span>

          <h2 className="about-title">
            About <span className="title-accent">Me</span>
          </h2>

          <p className="about-subtitle">
            Cybersecurity • Infrastructure • Networking
          </p>
        </div>

        <Row className="align-items-center about-content">
          <Col lg={5} md={5} className="about-img scroll-reveal">
            <div className="about-image-frame">
              <img
                src={laptopImg}
                alt="Cybersecurity, networking, and IT infrastructure illustration"
                className="img-fluid"
              />
            </div>
          </Col>

          <Col lg={7} md={7}>
            <div className="about-text scroll-reveal delay-1">
              <p className="about-lead">
                My primary focus is cybersecurity, with a strong interest in
                Security Operations, threat detection, incident response, and
                defensive security.
              </p>

              <p>
                My cybersecurity journey is supported by practical knowledge of
                enterprise networking, Windows and Linux administration, Active
                Directory, virtualization, business applications, and technical
                troubleshooting.
              </p>

              <p>
                I continuously develop and validate my skills through hands-on
                environments that simulate real enterprise networks, security
                monitoring, identity management, and incident investigation
                using technologies such as{" "}
                <span className="green">
                  Proxmox, OPNsense, Active Directory, Wazuh, Sysmon, Windows,
                  and Linux
                </span>
                .
              </p>

              <p>
                My goal is to help organizations build secure and reliable IT
                environments while growing into advanced defensive security
                roles and, over time, developing deeper offensive security
                skills.
              </p>

              <div className="about-focus">
                <span className="about-focus-label">Core Focus Areas</span>

                <div className="about-focus-list">
                  {focusAreas.map((area) => (
                    <span key={area} className="about-focus-item">
                      {area}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default About;